<template>
  <PassTimesForm />
</template>
<script>
import PassTimesForm from "@/v3components/Forms/PassTimesForm"
export default {
  name: "PassTimes",
  components: { PassTimesForm }
}
</script>
